import create from 'zustand'

export enum SandboxState {
  SEARCH = 'search',
  FORM = 'form',
  FIELDS = 'fields',
}

type Company = {
  domain: string
  name: string
  logo: string
}

type SandboxStore = {
  state: SandboxState
  setState: (state: SandboxState) => void
  company: Company
  setCompany: (company: Company) => void
}

export const useSandboxStore = create<SandboxStore>((set) => ({
  // Uncomment to test new individual components
  // state: import.meta.env.PROD ? SandboxState.SEARCH : SandboxState.FIELDS,
  state: SandboxState.SEARCH,
  setState: (state: SandboxState) => set({ state }),
  company: {
    domain: '',
    name: '',
    logo: '',
  },
  setCompany: (company: Company) => set({ company }),
}))
